module.exports = __webpack_public_path__ + "img/details-nocommerce.png?a6a5174b61c275e46e7ae5667d57ba83";